import InfiniteScroll from "react-infinite-scroll-component";
import { LoaderCircle } from "lucide-react";

import { setIndexs } from "store/header";
import { noneProfile } from "assets";
import UploadEmployeeImage from "components/app/upload-profile/UploadEmployeeImage";

import { Service } from "utils/services";
import ImageUrl from "components/app/image-url/ImageUrl";
import { useDispatch } from "react-redux";
import SkeletonMusicLibrariesTable from "pages/account-detail/music-libraries/skeleton/SkeletonMusicLibrariesTable";
const StaffTable = ({
  shopEmployee,
  fetchMoreShopEmployeeSearch,
  shopEmployeeLoading,
  listRef,
  setOpenPopoverIndex,
  selectProducts,
  setSelectedProductIds,
  selectedProductIds,
  handleClickUrl,
  setIsCreateStaff,
  setEditEmloyeeId,
  getShopEmployeeDetail,
  setShopEmployee,
  shopEmployeeLoadingState,
}: any) => {
  const dispatch = useDispatch();

  return (
    <InfiniteScroll
      dataLength={shopEmployee?.data?.length || 0}
      next={() =>
        fetchMoreShopEmployeeSearch({
          next: shopEmployeeLoading.nextPageUrl,
        })
      }
      scrollThreshold="90%"
      hasMore={!!shopEmployeeLoading.nextPageUrl}
      scrollableTarget="scrollableDiv"
      loader={
        <div className="absolute bottom-2 left-0 w-full flex justify-center mt-5">
          <LoaderCircle size={30} className="animate-spin text-yellow-400" />
        </div>
      }
    >
      <>
        {shopEmployeeLoadingState ? (
          <SkeletonMusicLibrariesTable />
        ) : (
          <table className="min-w-full border-collapse mb-20 rounded-md overflow-hidden">
            <thead className="sticky top-0 left-0 text-xs text-gray-700  bg-gray-300 dark:bg-[#2c3a52] dark:text-gray-400">
              <tr className="border-none  text-[15px]">
                <th className="py-5 text-start  px-4 first:rounded-tl-md last:rounded-tr-md ">Image</th>
                <th className=" px-4 text-start ">Staff Info. </th>
                <th className="text-start  pe-[70px] ps-4">Status</th>
                <th className="text-start px-4">Contact</th>
                <th className="text-start  px-4">Emergency Contact </th>
                <th className="text-start  px-4">Department</th>
                <th className="text-start  px-4">ID </th>
                <th className="text-start  pe-[70px] "> Joined Date</th>
                <th className="text-start  px-4"> Manager</th>
                <th className="text-start  px-4"> Benefit</th>
              </tr>
            </thead>
            <tbody ref={listRef}>
              {shopEmployee?.data?.map((item: any, index: number) => {
                return (
                  <tr
                    onClick={() => {
                      // if (item.is_deleted === 0) {
                      if (selectProducts) {
                        setSelectedProductIds((prev: any) => (prev.includes(item.id) ? prev.filter((id: any) => id !== item.id) : [...prev, item.id]));
                        return;
                      } else {
                        if (item.is_deleted === 0) {
                          dispatch(setIndexs(item.id));
                          setOpenPopoverIndex(1);
                          setIsCreateStaff(false);
                          setEditEmloyeeId(item.employee_id);
                          getShopEmployeeDetail(item.employee_id);
                          handleClickUrl(item?.id, "staff_id");
                        }
                      }
                    }}
                    key={index}
                    className={`group text-center cursor-pointer ${index % 2 === 0 ? "bg-gray-100 dark:bg-[#1e293b] " : "bg-gray-200 dark:bg-[#2c3a52] "} hover:bg-gray-300`}
                  >
                    <td className="relative w-[100px] h-[100px]  ">
                      <div
                        className={` ${
                          selectedProductIds.includes(item.id) ? "bg-white" : ""
                        } w-4 h-4 rounded-full flex items-center justify-center absolute left-[6px] top-[6px] z-50 text-xl  ${!selectProducts ? " hidden" : " block"}`}
                      >
                        {selectedProductIds.includes(item.id) ? (
                          <i className=" fa-solid  fa-circle-check text-blue-500 border-2 rounded-full border-white  "></i>
                        ) : (
                          <i className=" fa-regular fa-circle text-blue-500 border-2 border-transparent rounded-full "></i>
                        )}
                      </div>
                      {selectProducts === true && <div className="absolute inset-0 mx-auto top-[32px] z-50  w-8 h-8  text-white  rounded-full p-1"></div>}
                      {item.is_deleted === 0 ? (
                        <button
                          onClick={(event) => {
                            event.stopPropagation(); // Prevents opening the edit dialog
                          }}
                          className="absolute opacity-0 group-hover:opacity-100 group-hover:scale-110 transition-all duration-300 inset-0 z-10  mx-auto mt-[35px] w-8 h-8 text-white bg-black/50 rounded-full p-1"
                        >
                          <UploadEmployeeImage
                            editItemEmployee={item}
                            onUploadSuccess={({ res, name }) => {
                              setShopEmployee((prevItemGroups: any) => {
                                const updatedData = (prevItemGroups.data || []).map((item: any) => (item.id === res.id ? { ...item, ...res } : item));
                                const exists = updatedData.some((item: any) => item.id === res.id);
                                if (!exists) {
                                  updatedData.push(res);
                                }
                                return {
                                  ...prevItemGroups,
                                  data: updatedData,
                                };
                              });
                            }}
                          />
                        </button>
                      ) : (
                        <button
                          onClick={(event) => {
                            event.stopPropagation();
                          }}
                          className="font-semibold text-sm z-50 absolute flex items-center justify-center text-white shadow-md shadow-red-500 inset-0 mx-auto top-[40%] cursor-pointer w-[70px] h-8 bg-black/50 rounded-full p-1"
                        >
                          Deleted
                        </button>
                      )}

                      <img className={`w-full h-[100px] z-1 mx-auto relative  ${item.is_deleted === 1 && "opacity-50"} `} src={!item.picture ? noneProfile : item.picture} alt="" />
                    </td>
                    <td className="py-2 px-4 text-md  text-left align-top">
                      <p className="text-[15px] font-bold "> {item.local_name}</p>
                      <p className="text-md text-muted-foreground "> {item.english_name}</p>
                      <p className="text-md text-muted-foreground ">{item?.nationality}</p>
                    </td>
                    <td className="py-2 px-4  text-md  text-left align-top text-nowrap">
                      <p className="text-md "> {item?.gender}</p>
                      <p className="text-md text-muted-foreground"> {item?.marital_status}</p>
                      <p className="text-md flex items-center  gap-2  text-muted-foreground text-nowrap">
                        {(() => {
                          const date = new Date(item.date_of_birth);
                          const day = date.getDate();
                          const weekday = date.toLocaleDateString("en-GB", {
                            weekday: "short",
                          });
                          const month = date.toLocaleDateString("en-GB", {
                            month: "short",
                          });

                          const year = date.getFullYear();
                          return `${weekday}, ${day}-${month}-${year}`;
                        })()}
                      </p>
                    </td>
                    <td className="py-2 px-4 text-md  text-left align-top">
                      <p className="text-md "> {item?.phone_no}</p>
                      <p className="text-md line-clamp-1 text-muted-foreground"> {item?.email}</p>
                      <p className="text-md text-muted-foreground">{item?.address}</p>
                    </td>
                    <td className="py-2 px-4 text-md  text-left align-top">
                      <p className="text-md "> {item?.emergency_contact_name}</p>
                      <p className="text-md text-muted-foreground"> {item?.emergency_contact_phone_no}</p>
                      <p className="text-md text-muted-foreground line-clamp-1">{item?.emergency_contact_email}</p>
                    </td>
                    <td className="py-2 px-4 text-md  text-left align-top">
                      <p className="text-md line-clamp-1 "> {item?.department}</p>
                      <p className="text-md text-muted-foreground "> {item?.position}</p>
                      <div className="flex items-center gap-1 text-muted-foreground">
                        <p className="text-md text-nowrap"> {Service.formatTime(item?.timesheet?.starting_time)}</p>
                        {item?.timesheet?.starting_time && item?.timesheet?.ending_time && "-"}
                        <p className="text-md text-nowrap "> {Service.formatTime(item?.timesheet?.ending_time)}</p>
                      </div>
                    </td>
                    <td className="py-2 px-4  text-left align-top">
                      {/* <p className="text-[15px] font-bold ">{item?.card_no}</p> */}
                      <p className="text-[15px]  font-bold "> {item?.card_no}</p>

                      <p className="text-md text-muted-foreground"> {item?.id_card_no}</p>
                      <p className="text-md text-muted-foreground"> {item?.passport_no}</p>
                    </td>
                    <td className="py-2 text-md  text-left align-top text-nowrap">
                      {item.joined_date && <p className="text-md  ">{Service.formatDateTime(item.joined_date, { format: "ddd, DD-MMM-YYYY" })}</p>}
                      {item.last_working_date && <p className="text-md  ">{Service.formatDateTime(item.last_working_date, { format: "ddd, DD-MMM-YYYY" })}</p>}
                    </td>
                    <td className=" text-left align-top ">
                      {item?.managers?.map((managers: any, index: number) => {
                        return (
                          <div key={index} className="gap-3 flex items-center  rounded-md p-1  w-[180px] ">
                            <ImageUrl src={!managers?.picture ? noneProfile : managers?.picture} className=" h-[45px] w-[45px] rounded-full" alt={managers?.picture} />
                            <div className="flex flex-col text-start ">
                              <span className="w-full font-medium line-clamp-1 leading-none lg:text-md md:text-sm text-[15px]">
                                {managers?.local_name?.length > 12 ? `${managers?.local_name.slice(0, 12)}...` : managers?.local_name}
                                {/* {item.mana} */}
                              </span>
                              <span className="text-sm text-muted-foreground line-clamp-1">
                                {managers?.position?.length > 12 ? `${managers?.position.slice(0, 12)}...` : managers?.position}
                              </span>
                            </div>
                          </div>
                        );
                      })}
                    </td>
                    <td className="py-2 px-4 text-md  text-left align-top">
                      <p className="text-[15px]  font-bold "> {item?.basic_salary}</p>
                      <p className="text-md text-muted-foreground"> {item?.pay_method}</p>
                      <p className="text-md  text-muted-foreground">{item?.bank_account_no}</p>
                    </td>
                  </tr>
                );
              })}
              {!shopEmployee?.next_page_url ? (
                <p className="absolute bottom-0 left-0 w-full text-center mb-5 flex items-center justify-center">
                  <b>Nothing more to load!</b>
                </p>
              ) : (
                ""
              )}
            </tbody>
          </table>
        )}
      </>
    </InfiniteScroll>
  );
};

export default StaffTable;
